import { apiClient, buildParams } from "./client";

export async function getHealth() {
  const { data } = await apiClient.get("/health");
  return data;
}

export async function getAiModeStatus() {
  const { data } = await apiClient.get("/debug/ai-mode");
  return data;
}

export async function getKpis({ customerId, orgId } = {}) {
  const { data } = await apiClient.get("/api/kpis", {
    params: buildParams({ customerId, orgId }),
  });

  return data;
}

export async function getCustomers({ orgId } = {}) {
  const { data } = await apiClient.get("/api/rfm/customers", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function getSegmentSummary({ orgId } = {}) {
  const { data } = await apiClient.get("/api/rfm/segments/summary", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function getRevenueTrend({ customerId, orgId } = {}) {
  const { data } = await apiClient.get("/api/charts/revenue-trend", {
    params: buildParams({ customerId, orgId }),
  });
  return data;
}

export async function getTopProducts({ customerId, orgId } = {}) {
  const { data } = await apiClient.get("/api/charts/top-products", {
    params: buildParams({ customerId, orgId }),
  });
  return data;
}

export async function recalculateRfm({ orgId } = {}) {
  const { data } = await apiClient.post("/api/rfm/recalculate", null, {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function recalculateSuggestions({ orgId } = {}) {
  const { data } = await apiClient.post("/api/rfm/recalculate-suggestions", null, {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function getCustomerTimeline(customerId, { orgId } = {}) {
  const { data } = await apiClient.get("/api/actions/customer-timeline", {
    params: buildParams({ customerId, orgId }),
  });
  return data;
}

export async function getActionsContext({ orgId } = {}) {
  const { data } = await apiClient.get("/api/actions/context", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function generateCustomerPortfolioReport({ orgId, language, contactDetails } = {}) {
  const response = await apiClient.post("/api/reports/customer-portfolio", contactDetails || null, {
    params: buildParams({ orgId, language }),
    responseType: "blob",
    timeout: 60000,
  });
  return response.data;
}

export async function logCustomerAction(payload, { orgId } = {}) {
  const { data } = await apiClient.post("/api/actions/log", payload, {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function logSegmentAction(payload, { orgId } = {}) {
  const { data } = await apiClient.post("/api/actions/segment-log", payload, {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function getSegmentMessageTemplates({ orgId } = {}) {
  const { data } = await apiClient.get("/api/actions/message-templates", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function saveSegmentMessageTemplate(payload) {
  const { data } = await apiClient.put("/api/actions/message-template", payload);
  return data;
}

export async function resetSegmentMessageTemplate(payload) {
  const { data } = await apiClient.post("/api/actions/message-template/reset", payload);
  return data;
}

export async function getSuggestiveActionsConfig({ orgId } = {}) {
  const { data } = await apiClient.get("/api/actions/suggestive-actions", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function createCustomSuggestiveAction(payload) {
  const { data } = await apiClient.post("/api/actions/suggestive-actions/custom", payload);
  return data;
}

export async function updateCustomSuggestiveAction(payload) {
  const { data } = await apiClient.post("/api/actions/suggestive-actions/custom/update", payload);
  return data;
}

export async function toggleSuggestiveActionVisibility(payload) {
  const { data } = await apiClient.post("/api/actions/suggestive-actions/visibility", payload);
  return data;
}

export async function toggleSuggestiveActionsBulkVisibility(payload) {
  const { data } = await apiClient.post("/api/actions/suggestive-actions/visibility/bulk", payload);
  return data;
}

export async function deleteCustomSuggestiveAction(payload) {
  const { data } = await apiClient.post("/api/actions/suggestive-actions/custom/delete", payload);
  return data;
}

export async function resetSegmentSuggestiveActions(payload) {
  const { data } = await apiClient.post("/api/actions/suggestive-actions/reset-segment", payload);
  return data;
}

export async function getWhatsAppEmbeddedSignupConfig() {
  const { data } = await apiClient.get("/api/whatsapp/embedded-signup/config");
  return data;
}

export async function getWhatsAppConnection({ orgId } = {}) {
  const { data } = await apiClient.get("/api/whatsapp/connection", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function completeWhatsAppEmbeddedSignup(payload, { orgId } = {}) {
  const { data } = await apiClient.post("/api/whatsapp/embedded-signup/complete", payload, {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function disconnectWhatsAppConnection({ orgId } = {}) {
  const { data } = await apiClient.post("/api/whatsapp/connection/disconnect", null, {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function getWhatsAppTemplates({ orgId } = {}) {
  const { data } = await apiClient.get("/api/whatsapp/templates", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function getWhatsAppAnalytics({ orgId } = {}) {
  const { data } = await apiClient.get("/api/whatsapp/analytics", {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function sendWhatsAppSegmentCampaign(payload, { orgId } = {}) {
  const { data } = await apiClient.post("/api/whatsapp/segment-send", payload, {
    params: buildParams({ orgId }),
  });
  return data;
}

export async function createWhatsAppTemplateRequest(payload, { orgId } = {}) {
  const { data } = await apiClient.post("/api/whatsapp/template-requests", payload, {
    params: buildParams({ orgId }),
  });
  return data;
}
